import RincianInfoMitraGudang from './RincianInfoMitraGudang.vue'

export default RincianInfoMitraGudang
